import { defineStore } from 'pinia';
import { InspirationListParam, ExecutingJob, JobSimpleInfo } from '@lingtu/apis/entities';
import { apis } from '/@/apis';
import { merge, pull } from 'lodash-es';

interface UnCreatedJob extends JobSimpleInfo {
  type: 'blank' | 'inspiration';
}

interface JobState {
  jobs: Array<JobSimpleInfo>;
  jobQueryParams: InspirationListParam;
  excutingJobs: Array<ExecutingJob>;
  uncreatedJobs: Array<UnCreatedJob>;
  jobTotal: any;
}

export const useJobStore = defineStore({
  id: 'job',
  state: (): JobState => ({
    // 用户的灵感生成记录
    jobs: [],
    jobQueryParams: {},
    // 任务总数
    jobTotal: {
      number: 0,
    },
    // 用户当前尚未创建的空白灵感记录
    uncreatedJobs: [],
    // 正在进行中的任务
    excutingJobs: [],
  }),
  getters: {
    // 是否存在正在进行的任务
    excuting(): boolean {
      return this.excutingJobs.length > 0;
    },
    // 获取当前空白任务
    currentBlankJob(): UnCreatedJob | undefined {
      return this.uncreatedJobs?.find((v) => v.type === 'blank');
    },
  },
  actions: {
    // 获取用户所有任务
    async fetchJobs(params: InspirationListParam = { page: 1, pageSize: 20 }) {
      const { getCreationList } = apis.inspirations;
      this.jobQueryParams = merge(this.jobQueryParams, params, {
        page: 1,
        pageSize: 20,
      });
      this.jobs.splice(0, this.jobs.length);
      const { items, total } = await getCreationList(this.jobQueryParams);
      this.jobs.push(...items);
      this.jobTotal.number = total;
    },

    // 删除任务
    async deleteJob(id) {
      const { deleteCreation } = apis.inspirations;
      await deleteCreation(id);
      for (let i = 0; i < this.jobs.length; i++) {
        const job = this.jobs[i];
        if (job.id === id) {
          this.jobs.splice(i, 1);
          this.jobTotal.number -= 1;
          break;
        }
      }
    },

    // 当前查询条件不变，到下一页
    async fetchNextPageJobs() {
      const { getCreationList } = apis.inspirations;
      !!this.jobQueryParams.page ? this.jobQueryParams.page++ : (this.jobQueryParams.page = 1);
      const { items, total } = await getCreationList(this.jobQueryParams);
      this.jobs.push(...items);
      this.jobTotal.number = total;
      console.log(this.jobTotal);
    },
    // 新增未创建任务
    addUncreatedJob(job: UnCreatedJob) {
      // 当前只记录空白灵感
      if (job.type === 'blank') {
        const currentBlankJob = this.uncreatedJobs.find((v) => v.type === 'blank');
        if (currentBlankJob) {
          if (job.topic || job.debugger.referenceImages?.length > 0) {
            pull(this.uncreatedJobs, currentBlankJob);
            this.uncreatedJobs.push(job);
          }
        } else {
          this.uncreatedJobs.push(job);
        }
      }
    },
    // 删除未创建任务
    deleteUncreatedJob(type: 'blank' | 'inspiration') {
      if (type === 'blank') {
        pull(
          this.uncreatedJobs,
          this.uncreatedJobs.find((v) => v.type === 'blank'),
        );
      }
    },
    /**
     * 正在执行中
     */
    // 根据轮询情况，塞入正在执行任务的值
    async fetchExcutingJobs() {
      const { getExecutingJobs } = apis.jobs;
      const data = await getExecutingJobs();
      this.excutingJobs.splice(0, this.excutingJobs.length);
      this.excutingJobs.push(...data);
      return this.excutingJobs;
    },
  },
});
